import DefaultError from "@ext/errorHandlers/logic/DefaultError";

export type BpmnRenderErrorCode = "dom-unavailable" | "invalid-syntax" | "no-content";

export default class BpmnRenderError extends DefaultError {
	constructor(
		readonly code: BpmnRenderErrorCode,
		message: string,
		cause?: Error,
	) {
		super(message, cause);
	}
}

export const isBpmnEnvironmentFailure = (error: unknown): boolean =>
	error instanceof BpmnRenderError && error.code === "dom-unavailable";
